module.exports = __webpack_public_path__ + "static/b-tree-diagram-92d83f4d2f5033b6a05daea019e8c860.png";